module.exports = __webpack_public_path__ + "media/images/alf_logo-124b9545b30b3d9abb23558fefaa363d.svg";